<template lang="pug">
  div.col-12(v-if="currentUser.rights.simCallsProviders == true")
    .content-wrapper
      h2.m-0.mb-3 Управлениe префиксами провайдеров
      button.btn.btn-info.col-2.mb-3(v-on:click='createProvider' v-if="currentUser.rights.simCallsProvidersEdit") Добавить префикс
      table.table.table-hover
        thead
          tr
            th(v-for="h in columnsHeader" v-bind:key="h.key" v-on:click="sortBy(h.key)" v-bind:class="{ active: sortKey == h.key }") {{ h.title }}
              span(v-bind:class="['arrow', sortOrders[h.key] > 0 ? 'asc' : 'dsc']")
        tbody
          tr(v-for="row in providersList" v-bind:key="row.id")
            td(v-for="td in columnsHeader" v-bind:key="td.id") {{ row[td.key] }}
              span.td-actions(v-if="td.key === 'actions' && currentUser.rights.simCallsProvidersEdit")
                i.far.fa-pen.mr-2(v-on:click='showModal(row.id)')
                i.far.fa-trash.mr-2(v-on:click='deleteProvider(row.id)')
    modal(v-show="isModalVisible" v-on:close="closeModal")
      template(v-slot:header="")
        div.d-block.col-12
          h2 {{ modalData.provider.name }}
          .form-group
            button.btn.btn-info.col-2(v-on:click="saveProvider") Сохранить
            span &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            button.btn.btn-secondary.col-2(v-on:click='closeModal') Отмена
      template(v-slot:body="")
        div
          fieldset
            .form-group.col-12
              label Название
              input.form-control(v-model='modalData.provider.name' type='text' placeholder='Введите название провайдера' required='')
            .form-group.col-12
              label Префикс
              input.form-control(v-model='modalData.provider.prefix' type='text' placeholder='Введите префикс' required='')
      template(v-slot:footer="")
      .form-group.d-flex.justify-content-end.col-12
        button.btn.btn-secondary.col-2(v-on:click="closeModal") Закрыть
  .alert.alert-warning.alert-dismissible.fade.show(v-else role="alert")
    <strong>Внимание!</strong> У Вас нет прав доступа в этот раздел.
    button.close(type="button" data-dismiss="alert" aria-label="Close")
      span(aria-hidden="true") &times;
</template>

<script>
export default {
  data () {
    var columnsHeader = [
      {title: 'ID', key: 'id'},
      {title: 'Название', key: 'name'},
      {title: 'Префикс', key: 'prefix'},
      {title: 'Действия', key: 'actions'}
    ]
    // const FORMAT = 'YYYY-MM-DD'
    var sortOrders = {}
    columnsHeader.forEach(function (key) {
      sortOrders[key.key] = 1
    })
    return {
      sortKey: '',
      isModalVisible: false,
      modalData: {},
      emptyModalData: null,
      sortOrders: sortOrders,
      columnsHeader: columnsHeader,
      openProvider: 0,
      providers: []
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    providersList: function () {
      let list = []
      this.providers.forEach((item) => {
        item.actions = ''
        list.push(item)
      })
      if (this.sortKey) {
        let order = this.sortOrders[this.sortKey] || 1
        list = list.sort((a, b) => {
          let x = a[this.sortKey]
          let y = b[this.sortKey]
          if (typeof x == 'string') {
            x = x.toLowerCase()
            y = y.toLowerCase()
          }
          return (x === y ? 0 : x > y ? 1 : -1) * order
        })
      }
      return list
    },
    client_id: function () {
      return this.$store.getters.client_id
    },
    currentUser: function () {
      return this.$store.getters.user
    }
  },
  methods: {
    sortBy (key) {
      this.sortKey = key
      this.sortOrders[key] *= -1
    },
    showModal (Id = 0) {
      this.openProvider = Id
      if (Id < 1) {
        this.resetModalData()
        this.isModalVisible = true
        return true
      }
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/provider/get.php&id=' + Id)
        .then(response => {
          this.isModalVisible = true
          this.modalData.provider = response.data.provider
        })
    },
    closeModal () {
      this.openProvider = 0
      this.isModalVisible = false
    },
    resetModalData () {
      this.emptyModalData = {}
      this.modalData.provider = {id: 0, prefix: 0, name: ""}
      this.emptyModalData.provider = {id: 0, prefix: 0, name: ""}
    },
    createProvider () {
      this.showModal()
    },
    saveProvider () {
      let p = {}
      p.provider = JSON.stringify(this.modalData.provider)
      if (this.modalData.provider.id > 0) {
        p.url = '/api/provider/update.php'
      } else {
        p.url = '/api/provider/add.php'
      }
      // console.log(p)
      this.axios.post(this.systemSettings.api_host + '/simCalls.php', p)
        .then(() => { this.getProviderList() })
      this.closeModal()
    },
    startProject (id) {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/provider/update.php&is_active=1&id=' + id)
        .then(response => {
          this.getProviderList()
        })
    },
    stopProject (id) {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/provider/update.php&is_active=0&id=' + id)
        .then(response => {
          this.getProviderList()
        })
    },
    deleteProvider (id) {
      if (!confirm('Подтвердите удаление провайдера')) {
        return false
      }
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/provider/delete.php&id=' + id)
        .then(response => {
          this.getProviderList()
        })
    },
    getProviderList () {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/provider/get.php')
        .then(response => {
          this.providers = response.data.list
        })
    }
  },
  mounted () {
    this.resetModalData()
    this.getProviderList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/simCalls/providers.vue